module.exports = {"sk.js":{"brands":{"models":{"offers":{"confirm_load_preset":"Ste si istý, že chcete načítať sadu atribútov? Táto akcia prepíše všetky už vyplnené atribúty.","unable_to_load_preset":"Nepodarilo sa načítať sadu atribútov."}}},"confirm":{"destroy":"Ste si istý, že chcete vymazať daný záznam?"},"form":{"check_required_fields":"Prosím skontrolujte formulár a vyplňte všetky povinné polia."}}}


//////////////////
// WEBPACK FOOTER
// ./resources/js/messages.json
// module id = RU7V
// module chunks = 12 13